"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_TOPIC_SIZE_INFO = exports.FetchTopicSizeType = void 0;
var Long = require("long");
/**
 * The type of topic size information that is being returned.
 */
var FetchTopicSizeType;
(function (FetchTopicSizeType) {
    /**
     * Info not requested or no topic value.
     */
    FetchTopicSizeType[FetchTopicSizeType["NO_SIZE_INFO"] = 0] = "NO_SIZE_INFO";
    /**
     * Non-time series topic size info.
     */
    FetchTopicSizeType[FetchTopicSizeType["SIMPLE_SIZE_INFO"] = 1] = "SIMPLE_SIZE_INFO";
    /**
     * Times series topic size info.
     */
    FetchTopicSizeType[FetchTopicSizeType["TIME_SERIES_SIZE_INFO"] = 2] = "TIME_SERIES_SIZE_INFO";
})(FetchTopicSizeType = exports.FetchTopicSizeType || (exports.FetchTopicSizeType = {}));
/**
 * FetchTopicSizeInfo implementation for cases where size is not requested or the topic
 * has no value.
 */
exports.NO_TOPIC_SIZE_INFO = {
    infoType: FetchTopicSizeType.NO_SIZE_INFO,
    valueSize: 0,
    valueCount: 0,
    valueTotalSize: new Long(0)
};
